import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCart } from '@/contexts';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { SheetFooter } from '@/components/ui/sheet';
import { ShoppingCart, Plus, Minus, Trash2 } from 'lucide-react';

const CartDrawer = ({ onClose }) => {
  const { cart, updateQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (cart.items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-amber-600">
        <ShoppingCart className="w-16 h-16 mb-4 opacity-50" />
        <p>{t('cart.empty')}</p>
        <Button variant="link" className="text-green-600 mt-2" onClick={onClose}>{t('cart.goShopping')}</Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <ScrollArea className="flex-1 py-4">
        {cart.items.map((item) => {
          const price = item.product_price ?? item.price ?? 0;
          return (
            <div key={item.product_id} className="flex gap-4 py-4 border-b" data-testid={`cart-item-${item.product_id}`}>
              <img src={item.product_image} alt={item.product_name} className="w-20 h-20 object-cover rounded" />
              <div className="flex-1">
                <h4 className="font-medium text-sm">{item.product_name}</h4>
                <p className="text-green-600 font-bold">¥{price.toFixed(2)}</p>
                <div className="flex items-center gap-2 mt-2">
                  <Button size="icon" variant="outline" className="h-7 w-7" onClick={() => updateQuantity(item.product_id, item.quantity - 1)}>
                    <Minus className="w-3 h-3" />
                  </Button>
                  <span className="w-8 text-center">{item.quantity}</span>
                  <Button size="icon" variant="outline" className="h-7 w-7" onClick={() => updateQuantity(item.product_id, item.quantity + 1)}>
                    <Plus className="w-3 h-3" />
                  </Button>
                  <Button size="icon" variant="ghost" className="h-7 w-7 text-red-500 ml-auto" onClick={() => removeFromCart(item.product_id)}>
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          );
        })}
      </ScrollArea>
      <SheetFooter className="border-t pt-4">
        <div className="w-full space-y-4">
          <div className="flex justify-between text-lg font-bold">
            <span>{t('cart.total', '总计')}</span>
            <span className="text-green-600">¥{(cart.total ?? 0).toFixed(2)}</span>
          </div>
          <Button className="w-full bg-green-600 hover:bg-green-700" onClick={() => { onClose(); navigate('/checkout'); }} data-testid="checkout-button">
            {t('cart.checkout', '去结算')}
          </Button>
        </div>
      </SheetFooter>
    </div>
  );
};

export default CartDrawer;
